import type { ProspectClosingChecklistMemberDto } from '../../services/tenantApi';
import type { ClosingMember, ClosingPersonalState } from './closing-model';

/** Applicant roster from the closing checklist (same names as Apply). */
export function closingMembersFromChecklistRows(
  rows: ProspectClosingChecklistMemberDto[],
  personal: Record<string, ClosingPersonalState>,
  viewerPersonId: string | null,
): ClosingMember[] {
  return rows.map((member) => ({
    id: member.personId,
    displayName: member.displayName.trim() || 'Group member',
    isViewer: viewerPersonId != null && member.personId === viewerPersonId,
    headshotDocumentId: personal[member.personId]?.headshotDocumentId ?? null,
  }));
}
